import React from "react";
import POSProductList from "../pages/POSProductList";
import CartSidebar from "../components/cart/CartSidebar";
import { POSProductsProvider } from "../contexts/POSProductContext";
import { CartProvider } from "../contexts/cartContext";

import { Menu, X, ShoppingCart } from "lucide-react";
import { useTheme } from "../../CommonComponents/ThemeProvider";
import { useCart } from "../contexts/cartContext";

function Dashboard() {
    const { currentTheme } = useTheme();
    const { cart } = useCart();
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth < 768; // Tailwind's md breakpoint
        }
        return false;
    });

    React.useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setSidebarCollapsed(true);
            } else {
                setSidebarCollapsed(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <POSProductsProvider>
            <CartProvider>
                <div className="flex flex-1 gap-6 overflow-hidden relative">
                    <main className="flex-1 overflow-y-auto scrollbar-thin">
                        <POSProductList sidebarCollapsed={sidebarCollapsed} />
                    </main>
                    {/* Sidebar toggle button removed; close handled inside CartSidebar */}
                    {/* On small screens, floating sidebar overlays the grid. On md and up, sidebar is part of the flex layout. */}
                    {/* Small screens: floating sidebar overlays the grid. */}
                    {/* Floating cart button for small screens when sidebar is hidden */}
                    {sidebarCollapsed && (
                        <button
                            className="fixed bottom-6 right-6 z-40 bg-primary text-white rounded-full p-4 shadow-lg md:hidden"
                            onClick={() => setSidebarCollapsed(false)}
                            aria-label="Show cart sidebar"
                            type="button"
                        >
                            <span className="sr-only">Show cart</span>
                            <span className="flex items-center justify-center relative">
                                <ShoppingCart
                                    size={28}
                                    className="text-white"
                                />
                                {/* Cart counter badge */}
                                {cart && cart.length > 0 && (
                                    <span
                                        className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 shadow"
                                        style={{ minWidth: 20, textAlign: 'center' }}
                                    >
                                        {cart.reduce((sum, i) => sum + i.qty, 0)}
                                    </span>
                                )}
                            </span>
                        </button>
                    )}
                    {!sidebarCollapsed && (
                        <>
                            <aside
                                className="fixed top-20 overflow-x-hidden bottom-4 right-0 w-72 flex flex-col transition-all duration-300 bg-white shadow-2xl rounded-l-xl z-50 md:hidden"
                            >
                                <CartSidebar onCloseSidebar={() => setSidebarCollapsed(true)} />
                            </aside>
                            <div
                                className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 md:hidden"
                                onClick={() => setSidebarCollapsed(true)}
                                aria-label="Close cart sidebar overlay"
                            />
                        </>
                    )}
                    {/* md and up: sidebar in flex layout */}
                    <aside
                        className={`w-72 flex-col overflow-x-hidden transition-all duration-300 rounded-xl hidden md:flex ${sidebarCollapsed ? 'hidden' : 'flex'}`}
                    >
                        <CartSidebar onCloseSidebar={() => setSidebarCollapsed(true)} />
                    </aside>
                </div>
            </CartProvider>
        </POSProductsProvider>
    );
}

export default Dashboard;
